<template>
  <div>
    <hb-modal v-model="showLinkSenderDialogComputed" size="medium" :title="title" :footerOff="false" confirmation
      @close="$emit('close',{linkType})" :footerCancelOption="false">
      <template v-slot:content>
        <div v-if="!showModal && !lockReload" style="height: 200px; display: flex; align-items: center; justify-content: center;" class="px-6 py-4 pb-2">
          <v-progress-circular width="2" size="32" indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-if="showModal">
          <div class="px-6 py-4">
            <div class="pb-2">
              <!-- <template v-if="showSendError">
                <div>
                  <strong>
                    Send Rental Link Failed!
                  </strong> 

                  <ul>
                    <li>The selected space is now marked as Pending.</li>
                    <li>You can click Retry button to send the Link again </li>
                    <li><strong>Important: </strong> Important: If you make any changes after sending, you'll need to resend the link.</li>
                    Do you want to retry?
                  </ul>
                </div>
              </template> -->
              <template>
                {{ content }}
              </template>
            </div>
            <template>
              <div class="mt-4" v-show="!!leadEmail">
                <HbCheckbox v-model="checkboxEmail" label="Email" condensed />
                <HbTextField v-model="leadEmail" readonly condensed />
              </div>
              <div class="mt-4" v-show="!!leadText">
                <HbCheckbox v-model="checkboxText" label="Text" condensed />
                <HbTextField v-model="leadText" readonly condensed />
              </div>
            </template>
          </div>
        </div>
      </template>

      <template v-slot:right-actions>
        <hb-link @click="closeDialogHandler">Cancel</hb-link>
        <hb-btn v-if="showSendError" @click="retrySendLink" :disabled="!enableBtn">Retry</hb-btn>
        <hb-btn v-else @click="sendLinkFlowRouter" :disabled="!enableBtn">Send</hb-btn>
      </template>
    </hb-modal>

    <!-- Confirmation Dialog for Rental Link -->
    <hb-modal v-model="showRentalConfirmDialog" size="medium" title="Confirmation" :footerCancelOption="false" confirmation>
      <template v-slot:content>
        <div class="px-6 py-4 pb-2">
          <strong>
            Send Rental Link to Customer?
          </strong> 

          <ul>
            <li>You're about to send a rental link for the selected space.</li>
            <li>Once sent, the space will be marked as Pending and temporarily held.</li>
            <li>The customer can now complete the rental using the link provided.</li>
            <li><strong>Important: </strong> Important: If you make any changes after sending, you'll need to resend the link.</li>
            Do you want to proceed?
          </ul>
        </div>
      </template>
      <template v-slot:right-actions>
        <hb-link @click="showRentalConfirmDialog = false">Cancel</hb-link>
        <hb-btn color="primary" @click="confirmRentalAction">Send Link & Return to Dashboard</hb-btn>
      </template>
    </hb-modal>
  </div>
</template>
  
<script>
import { notificationMixin } from '../../../mixins/notificationMixin';
import { mapGetters, mapActions } from 'vuex';
import api from '../../../assets/api.js'
import { parsePhoneNumber } from 'libphonenumber-js';
export default {
  data() {
    return {
      checkboxEmail: false,
      checkboxText: false,
      leadEmail: "",
      leadText: "",
      enableBtn: false,
      leadData: "",
      preventDialogClose:false,
      showModal:false,
      phoneId:null,
      showRentalConfirmDialog: false,
      lockReload:false,
      failureOccurred:false,
      showSendError: false
    };
  },
  props: ["title", "content", "contactData", "showLinkSenderDialog",'linkType','form', 'fileData', 'sendQuotePropertyId', 'sendQuoteEmailData', 'lead_id', 'property','stepper'],
  mixins: [notificationMixin],
  methods: {
    async sendTheLinks() {
      this.enableBtn=false;
      let body = {
        unit: this.configuration_unit,
        send_link_of: this.linkType,
        lead:this.lead,
        reservation: this.reservation,
      }
      if(body?.lead?.Property?.id){
        body.lead.Property.custom_web_url = this.property?.custom_web_url
      }
      let sendQuoteMailBody = {
        message: "",
        subject: "Send Quote Summary",
        space: "Tenant",
        send_email: true,
        sms: [],
        attachments: [
          {
            content_type: "application/pdf"
          }
        ],
        sendQuotePropUnitData: this.sendQuoteEmailData,
        upload_id:'',
        fileData: this.fileData,
        primary_contact_id: this.leadData?.contact?.id,
        property_id: this.sendQuotePropertyId,
        contact_type: "primary",
        lead_id: this.lead_id
      }
      if(this.getSettings?.isCustomWebUrl === '1'){
        body.isCustomWebUrl = true;
        sendQuoteMailBody.isCustomWebUrl = true;
      }
      if(this.linkType == "rental"){
        body.Addresses = this.contact?.Addresses
        body.license = {
          driver_license: this.contact?.driver_license,
          driver_license_city: this.contact?.driver_license_city,
          driver_license_state: this.contact?.driver_license_state,
          driver_license_country: this.contact?.driver_license_country,
          driver_license_exp: this.contact?.driver_license_exp,
        }
      }
      
      let sendQuoteSMSBody = {
        message: '',
        subject: ' ',
        space: "Tenant",
        send_email: false,
        sms: [this.phoneId],
        attachments: [
          {
            content_type: "application/pdf"
          }
        ],
        upload_id:'',
        primary_contact_id: this.leadData?.contact?.id,
        contact_type: "primary"
      }
      if (this.sendQuoteEmailData?.length == 1) {
				sendQuoteSMSBody.isSinglePropery = true;
        sendQuoteSMSBody.property_id=  this.sendQuoteEmailData[0].id;
			}else{
        sendQuoteSMSBody.property_id =  this.sendQuotePropertyId;
      }
      // check which one is active and send the link based on the bool value
      try {
        this.preventDialogClose=true
        if(this.linkType=='send_quote'){
         let response = await this.upload();
         if(response?.uploads?.id){
          sendQuoteMailBody.message = `<p>Hi, ${this.leadData?.contact?.first} ${this.leadData?.contact?.last}, \n Below find the rental quote <p>`
          sendQuoteMailBody.upload_id = [response.uploads.id];
          if (this.checkboxText) {
            // let res={};
            let res = await api.get(this, api.SEND_SHORTEN_LINK + `?upload_id=${response.uploads.id}&contact_id=${this.leadData?.contact?.id}`);
            sendQuoteSMSBody.message = ' ';
            sendQuoteSMSBody.rentalQuoteLink = res?.short_url;
          }
         }
        }
        if (this.checkboxEmail) {
          await this.sendViaEmail((this.linkType == "send_quote")?sendQuoteMailBody:body)
        }
        if (this.checkboxText) {
          await this.sendViaText((this.linkType == "send_quote")?sendQuoteSMSBody:body)
        }
        let successOptions = this.linkType == "rental" ? ["The customer can now complete the rental using the link provided.", "The selected space is now marked as Pending. Need to make changes?", "You’ll need to resend the link."] : []
        this.showMessageNotification({ type: 'success', description: (this.linkType == "send_quote")?'You have successfully sent rental quote.':this.linkType == "rental" ? 'Rental Link Sent Successfully.' : 'You have successfully sent link.', items:successOptions});
        this.$emit('closeLinkSender',{linkType:this.linkType})
        this.$emit('redirectPage',{linkType:this.linkType})
        this.enableBtn=true;
        // this.showSendError = false
      } catch (error) {
        this.failureOccurred = true
        this.preventDialogClose=false
        this.enableBtn=true;
        // this.showSendError = true
        console.log("error occurred", error);
        this.showMessageNotification({ type: 'error', description: 'The link could not be sent due to an internal error.', list: error });
      }
    },
    async sendViaEmail(body) {
      try {
        if (!(this.linkType == "send_quote")) {
          body.type = "email"
          body.to = this.leadEmail
        }
          if (this.linkType == "rental")
            await api.post(this, api.SEND_RENTAL_LINK,body)
          else if (this.linkType == "reservation")
            await api.post(this, api.SEND_RESERVATION_LINK,body)
          else if (this.linkType == "send_quote")
            await api.post(this, api.CONTACTS + body.primary_contact_id + '/send-quote', body);
        console.log("send email");
      } catch (error) {
        // console.log(error);
        throw new Error("in Email: " + error)
      }
    },
    async sendViaText(body) {
      try {
        console.log("send text");
         body.type = "sms"
         body.to = this.leadText
        if (this.linkType == "rental")
          await api.post(this, api.SEND_RENTAL_LINK,body)
        else if (this.linkType == "reservation")
          await api.post(this, api.SEND_RESERVATION_LINK,body)
        else if (this.linkType == "send_quote")
          await api.post(this, api.CONTACTS + body.primary_contact_id + '/send-message?smsType=send_quote', body);
      } catch (error) {
        throw new Error("in Text: " + error)
      }

    },
    findAndSetLeadEmail() {
      // find email and set leadEmail here
      this.leadEmail = this.leadData?.contact?.email
    },
    findAndSetLeadText() {
      // find text ans set leadText here
      this.leadText = this.formatPhoneNumber(this.leadData?.contact?.Phones.filter(item => item.sms === true).map(item => (this.$set(this, 'phoneId', item.id), item.phone))[0]);      
    },
    async getLeadData() {
      if(!this.lockReload){
      this.showModal = false;
      this.leadData = await api.get(this, api.CONTACTS + this.lead.contact_id)
      if (this.leadData?.contact) {
        this.findAndSetLeadEmail()
        this.findAndSetLeadText()
      }
      this.showModal = true;
    }
      console.log("this.leadData", this.leadData);
    },
    formatPhoneNumber(value) {
      if (!value) return '';
      try {
        var parsedPhoneNumber = parsePhoneNumber('+' + value);

        if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
          if (parsedPhoneNumber.country === 'US') {
            return '+1 ' + parsedPhoneNumber.formatNational();
          } else {
            return parsedPhoneNumber.formatInternational();
          }
        } else {
          value = value.toString();

          var numbers = value.replace(/\D/g, ''), char = { 0: '(', 3: ') ', 6: '-' };
          value = '';
          for (var i = 0; i < numbers.length; i++) {
            value += (char[i] || '') + numbers[i];
          }
        }
      } catch (err) {
      }
      return value;
      // return formattedPhoneNumber
    },
    setGdsFacilityId() {
      // set gds facility_id
      this.gds_facility_id = this.facilityList.filter(item => item.id === this.property_id).map(item => item.gds_id)[0]
      this.owner_id = '' // remove owner_id
      if (this.gds_facility_id == '' || !this.gds_facility_id)
        this.showMessageNotification({
          type: "error",
          description: `Unable to find GDS config is missing for selected property`,
        });
    },
    closeDialogHandler() {
      // this.showSendError = false;
      if (this.preventDialogClose) {
        
      } else {
        this.$emit('close', { linkType: this.linkType })
        this.failureOccurred = false
      }
    },
    async upload() {
      if (this.fileData) {
        let body = {
          document_type: this.type,
          document_type_id: this.document_type_id
        }
        let response = await api.postFile(this, api.CONTACTS + this.leadData?.contact?.id + '/upload', body, [this.fileData]);
        return response
      } else {
        return false;
      }
    },
    ...mapActions({
      fetchSpaceMix: "settingsStore/fetchCategories"
    }),
    async sendLinkFlowRouter(){
      if(this.linkType == "rental" && this.stepper == 1){
        // Show confirmation dialog instead of emitting immediately
        this.lockReload = true
        this.showLinkSenderDialogComputed = false
        // this.showMessageNotification({ type: 'success', description: 'Lead status has been updated to pending'});

      this.$emit('save_lease_rental',{flowType:"RENTAL_LINK"});

        // this.showRentalConfirmDialog = true;
      }
      else{
        // the normal way!!
        await this.sendTheLinks()
      }
    },
    confirmRentalAction() {
      // this.showRentalConfirmDialog = false;
      this.$emit('save_lease_rental',{flowType:"RENTAL_LINK"});

      // this.$emit('save_lease_rental');
    },
    retrySendLink() {
      // this.showSendError = false;
      this.sendTheLinks();
    },
  },
  watch: {
    leadEmail() {
      if(this.leadEmail){
        this.checkboxEmail = true;
        this.enableBtn = true;
      }
    },
    leadText() {
      if(this.leadText){
        this.checkboxText = true;
        this.enableBtn = true;
    }
    },
    checkboxEmail() {
      if (this.checkboxEmail || this.checkboxText) {
        this.enableBtn = true
      } else {
        this.enableBtn = false
      }
    },
    checkboxText() {
      if (this.checkboxText || this.checkboxEmail) {
        this.enableBtn = true
      } else {
        this.enableBtn = false
      }
    },
    contactData() {
      if (this.contactData?.length) {
        this.findAndSetLeadEmail()
        this.findAndSetLeadText()
      }
    },
    async lead() {
      console.log('lead data', this.lead);
      if (this?.lead?.contact_id) {
        await this.getLeadData()
      }
    },
    async form(){
      if (this?.lead?.contact_id) {
        await this.getLeadData()
      }
    }
  },
  computed: {
    ...mapGetters({
      configuration_unit: 'onBoardingStore/configuration_unit',
      lead: 'onBoardingStore/lead',
      unit: 'onBoardingStore/unit',
      spaceMix: "settingsStore/unitMixes",
      categories: 'filterStore/unit_category',
      reservation: 'onBoardingStore/reservation',
      lease: 'onBoardingStore/lease',
      getSettings: 'authenticationStore/getSettings'
    }),
    contact: {
      get() { return this.$store.getters['onBoardingStore/contact'] },
      set(val) { return this.$store.commit('onBoardingStore/setContact', val) }
    },
    showLinkSenderDialogComputed: {
      get() {
        return this.showLinkSenderDialog;
      },
      set(value) {
        this.$emit('update:showLinkSenderDialog', value);
      }
    },
  },
  beforeDestroy() {
    // console.log('accha to mai chalta hu');
  },
  async mounted() {
    await this.fetchSpaceMix()
    if (this?.lead?.contact_id) {
      await this.getLeadData()
    }
    // this.showSendError = false
  },
  created(){

  }
};
</script>
  
<style>
.dialog-lead-intake {}
</style>